import { createColumnHelper } from '@tanstack/react-table';

import { emailList } from 'components/modules/ManufacturerModal/ManufacturerModal.utils';
import { Manufacturer } from 'types/manufacturer';

const col = createColumnHelper<Manufacturer>();

/** Columns of Inventory → Manufacturers (ClickUp 86bceudwp). */
export const buildManufacturerColumns = () => [
  col.accessor((m) => m?.name || '-', {
    id: 'name',
    header: 'Name',
    minSize: 180,
  }),
  // Email is a list; show every address.
  col.accessor((m) => emailList(m?.email).join(', ') || '-', {
    id: 'email',
    header: 'Email',
    minSize: 240,
  }),
  col.accessor((m) => m?.address?.fullAddress || '-', {
    id: 'address',
    header: 'Address',
    minSize: 300,
  }),
];
